import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  withStyles, Icon, Divider, Link, Avatar,
} from '@material-ui/core';

const types = {
  google: 'Google',
  facebook: 'Facebook',
  tripadvisor: 'TripAdvisor',
};

const styles = {
  author: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  link: {
    fontWeight: 'bold',
    margin: '0 5px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginBottom: '10px',
  },
  profilePicture: {
    width: '30px',
    height: '30px',
    borderRadius: '15px',
    marginRight: '5px',
    display: 'inline-flex',
  },
  review: {
    paddingBottom: '15px',
  },
  star: {
    fontSize: '1rem',
  },
  stars: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
  text: {
    margin: '10px 0',
  },
};

class Review extends PureComponent {
  renderAuthor() {
    const {
      author, postedAt, type, classes, url,
    } = this.props;

    const date = moment(postedAt).format('DD.MM.YYYY');

    return (
      <div className={classes.author}>
        <Avatar
          alt={author.name}
          referrerPolicy="no-referrer"
          className={classes.profilePicture}
          src={author.profileImageUrl}
        />
        <Link
          href={author.profileUrl}
          target="_blank"
          rel="noreferrer"
          referrerPolicy="no-referrer"
          className={classes.link}
        >
          {author.name}
        </Link>
        {` | ${date} via `}
        <Link
          href={url}
          target="_blank"
          rel="noreferrer"
          referrerPolicy="no-referrer"
          className={classes.link}
        >
          {types[type] || type}
        </Link>
      </div>
    );
  }

  renderRatings() {
    const { classes, ratings } = this.props;
    if (!ratings) {
      return null;
    }

    const rating = ratings.find(r => r.category === 'Gesamt');
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <Icon
        // eslint-disable-next-line no-underscore-dangle
          key={`${rating._id}_${i}`}
          className={classes.star}
        >
          {i < rating.rating ? 'star' : 'star_outline' }
        </Icon>,
      );
    }
    return (
      <div className={classes.stars}>
        {stars.reverse()}
      </div>
    );
  }

  render() {
    const { classes, text } = this.props;

    return (
      <div className={classes.review}>
        <div className={classes.header}>
          {this.renderAuthor()}
          {this.renderRatings()}
        </div>
        {text && [
          <Divider key="divider" />,
          <div key="text" className={classes.text}>
            {text}
          </div>,
        ]}
        <Divider />
      </div>
    );
  }
}


Review.propTypes = {
  author: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  postedAt: PropTypes.string.isRequired,
  text: PropTypes.string,
  type: PropTypes.string.isRequired,
  ratings: PropTypes.array,
  url: PropTypes.string.isRequired,
};

Review.defaultProps = {
  text: null,
  ratings: null,
};

export default withStyles(styles)(Review);
